<template>
    <svg
        :width="`${width}px`"
        height="16px"
        :viewBox="`0 0 ${width} 16`"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
    >
        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g transform="translate(10,0)">
                <rect
                    id="background"
                    :fill="barBackgroundColor"
                    x="0"
                    y="0"
                    :width="barWidth"
                    height="16"
                    opacity=".8"
                />
                <rect id="bar" fill="#00CAEA" x="0" y="0" :width="currentX" height="16" v-if="currentX > 0">
                    <animate attributeName="width" :values="`0;${currentX}`" dur="1s" />
                </rect>
            </g>
        </g>
    </svg>
</template>
<script>
export default {
    props: {
        min: {
            type: Number,
            default: 0.1,
        },
        max: {
            type: Number,
            default: 9.9,
        },
        current: {
            type: Number,
        },
        width: {
            type: Number,
            default: 400,
        },
        barBackgroundColor: {
            type: String,
            default: '#F4F3F6',
        },
    },
    computed: {
        currentX() {
            return this.barX(this.current ?? 0)
        },
        dividerWidth() {
            return 3
        },
        barWidth() {
            return this.width - 20
        },
    },
    methods: {
        barX(rating) {
            return ((rating - this.min) / (this.max - this.min)) * this.barWidth
        },
    },
}
</script>
